import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue } from 'redux-form';
import Titulo from '../comum/Titulo';
import {
    getFinanceiroAgencia,
    getFinanceiroCaixa,
    getPerfisEmpresa,
    hasPerfil,
    PERFIL_ADMIN,
} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import determinarPaginaAtual from '../../actions/venda/determinarPaginaAtualVenda'
import limparFiltroEncomenda from '../../actions/encomenda/limparFiltroEncomenda'
import ModalCadastroValorPesoEncomenda from './ModalCadastroValorPesoEncomenda';
import buscarEncomendasEmpresa from '../../actions/encomenda/buscarEncomendasEmpresa';
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import Encomenda from './Encomenda';
import ModalConfirmacaoCancelamentoEncomenda from './ModalConfirmacaoCancelamentoEncomenda';
import CampoSelecionarEmpresa from '../layout/CampoSelecionarEmpresa';
import ModalAlterarFormaPagamento from '../pedido/ModalAlterarFormaPagamento';
import ModalInformarComprovante from '../pedido/ModalInformarComprovante';
import ModalImagensEncomenda from './ModalImagensEncomenda';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import PaginacaoEncomenda from './PaginacaoEncomenda';
import BotoesPaginacaoEncomenda from './BotoesPaginacaoEncomenda';
import { alterouFiltro, alterouPagina } from '../../util/filtros';
import determinarPaginaAtualEncomenda from '../../actions/encomenda/determinarPaginaAtualEncomenda';
import ModalHistoricoEncomenda from './ModalHistoricoEncomenda';
import PainelFiltragem from './PainelFiltrosEncomendas';
import { gerarHashForString } from '../../util/stringUtil';
import ModalInformarEntregaEncomenda from './ModalInformarEntregaEncomenda';
import ModalTransmitirCte from './ModalTransmitirCte';
import buscarOpcoesFiltrosEmissaoesCte from '../../actions/cteos/buscarOpcoesFiltrosEmissaoesCte';
import buscarSeUsuarioVendeEncomendaComCte from '../../actions/usuario/buscarSeUsuarioVendeEncomendaComCte';

export const CabecalhoTabela = () => (
    <div id="header-tabela" className="lista-table d-md-block d-lg-block d-xl-block d-none d-sm-none">
      <div className="row cabecalho-desktop">
        <div className="col">Exibir detalhes</div>
        <div className="col">Nº Pedido</div>
        <div className="col">Vendedor</div>
        <div className="col">Descrição encomenda</div>
        <div className="col">Remetente</div>
        <div className="col">Situação Ct-e</div>
        <div className="col">Status evento Ct-e</div>
        <div className="col">Data emissão</div>
        <div className="col">Status pedido</div>
        <div className="col">Valor</div>
        <div className="col">Ações</div>
      </div>
    </div>
  );

export class PainelGerenciarEncomendas extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            arquivos: [],
            imagensInformarEntrega: [],
            historicos: [],
            idPedido: null
        };
    }

    UNSAFE_componentWillMount() {
        this.props.determinarPaginaAtualEncomenda(1)
        this.props.limparFiltroEncomenda();
    }

    componentDidMount() {
        if (this.props.empresaSelecionada.id) {
            this.buscarEncomendas()
            this.props.buscarOpcoesFiltrosEmissaoesCte(this.props.empresaSelecionada.id);
            this.props.buscarSeUsuarioVendeEncomendaComCte(this.props.empresaSelecionada.id);
        }
    }

    buscarEncomendas() {
        this.props.buscarEncomendasEmpresa(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
    }

    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps) || alterouFiltro(this.props, prevProps) || alterouPagina(this.props, prevProps)) {
            this.buscarEncomendas()
            if (!alterouPagina(this.props, prevProps)) {
                this.props.determinarPaginaAtualEncomenda(1)
            }
        }
    }

    preencherModalImagensEncomenda(imagens) {
        if (imagens && imagens.length > 0) {
            this.setState({ arquivos: this.mapearObjetoImagem(imagens) })
        }
    }

    preencherModalInformarEntregaEncomenda(imagensInformarEntrega) {
        if (imagensInformarEntrega && imagensInformarEntrega.length > 0) {
            this.setState({ imagensInformarEntrega: this.mapearObjetoImagem(imagensInformarEntrega) })
        }
    }

    mapearObjetoImagem(imagens) {
        return imagens.map(it => {
            return {
                hash: gerarHashForString(`${it.nome}`),
                ...it
            }
        });
    }

    removerImagemInformarEntrega(arquivo) {
        const arquivos = [...this.state.imagensInformarEntrega];
        const array = arquivos.filter(it => it.hash != arquivo.hash);

        this.setState({ imagensInformarEntrega: array });
    }

    adicionarImagensInformarEntrega(arquivos) {
        this.setState({ imagensInformarEntrega: arquivos });
    }

    limparImagensInformarEntrega() {
        this.setState({ imagensInformarEntrega: [] });
    }

    removerImagem(arquivo) {
        const arquivos = [...this.state.arquivos];
        const array = arquivos.filter(it => it.hash != arquivo.hash);

        this.setState({ arquivos: array });
    }

    adicionarImagens(arquivos) {
        this.setState({ arquivos });
    }

    limparImagens() {
        this.setState({ arquivos: [] });
    }

    selecionarHistoricos(historicos, idPedido) {
        this.setState({
            historicos,
            idPedido
        });
    }

    exibirEncomendas() {
        return this.props.encomendas
            .map((encomenda, index) => <Encomenda key={index} encomenda={encomenda}
                selecionarHistoricos={this.selecionarHistoricos.bind(this)}
                alterarExibicao={this.alterarExibicao}
                preencherModalImagensEncomenda={this.preencherModalImagensEncomenda.bind(this)}
                preencherModalInformarEntregaEncomenda={this.preencherModalInformarEntregaEncomenda.bind(this)}
                indice={index} />)
    }

    exibirTabelaEncomendas() {
        if (this.props.encomendas && this.props.encomendas.length) {
            return (<div className='mt-4'>
                <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoEncomenda}
                    BotoesPaginacao={BotoesPaginacaoEncomenda}
                    encomendas={this.props.encomendas}
                    empresaSelecionada={this.props.empresaSelecionada}>
                        <CabecalhoTabela />
                    <div className="lista-table">
                        {this.exibirEncomendas()}
                    </div>
                </CabecalhoRodapeTabela>

            </div>
            )
        }
        return <div>Nenhuma encomenda cadastrada</div>;
    }

    render() {
        if (this.props.empresaSelecionada.habilitadoEncomenda || hasPerfil(PERFIL_ADMIN)) {
            return (
                <Autorizacao perfisPermitidos={[PERFIL_ADMIN, ...getPerfisEmpresa(this.props.empresaSelecionada.id),
                    getFinanceiroAgencia(this.props.empresaSelecionada.id),
                     getFinanceiroCaixa(this.props.empresaSelecionada.id)]}
                    empresaSelecionada={this.props.empresaSelecionada}>
                    <div>
                        <div className="row internas">
                            <Titulo texto="Gerenciar encomendas" urlRetorno="/menu-encomendas" />
                            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                                <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                                    <ul className="nav navbar-nav ml-auto opcoes-menu menu-desktop">
                                        <li className="nav-item dropdown nome-empresa">
                                            <div className='col-md-6'>
                                                <CampoSelecionarEmpresa />
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </Autorizacao>
                            <div className="col-12 filtro-busca">
                                <PainelFiltragem />
                            </div>
                            <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                                {this.exibirTabelaEncomendas()}
                            </div>
                        </div>
                    </div>
                    <ModalCadastroValorPesoEncomenda />
                    <ModalConfirmacaoCancelamentoEncomenda buscarPedidos={this.buscarEncomendas.bind(this)} />
                    <ModalAlterarFormaPagamento buscarPedidos={this.buscarEncomendas.bind(this)} />
                    <ModalInformarComprovante buscarPedidos={this.buscarEncomendas.bind(this)} />
                    <ModalImagensEncomenda buscarEncomendas={this.buscarEncomendas.bind(this)}
                        arquivos={this.state.arquivos}
                        removerImagem={this.removerImagem.bind(this)}
                        adicionarImagens={this.adicionarImagens.bind(this)}
                        limparImagens={this.limparImagens.bind(this)} />
                    <ModalInformarEntregaEncomenda buscarEncomendas={this.buscarEncomendas.bind(this)}
                        arquivos={this.state.imagensInformarEntrega}
                        removerImagem={this.removerImagemInformarEntrega.bind(this)}
                        adicionarImagens={this.adicionarImagensInformarEntrega.bind(this)}
                        limparImagens={this.limparImagensInformarEntrega.bind(this)}/>
                    <ModalHistoricoEncomenda historicos={this.state.historicos} idPedido={this.state.idPedido} />
                    <ModalTransmitirCte buscarPedidos={this.buscarEncomendas.bind(this)} />
                </Autorizacao>
            )
        }
        return '';
    }
}


export const mapStateToProps = state => (
    {
        encomendas: state.encomendas.encomendas,
        empresaSelecionada: state.empresaSelecionada,
        changeFieldValue,
        filtrosAdicionados: state.filtrosAdicionadosEncomenda,
        paginaAtual: state.paginaAtualEncomenda,
        registrosPorPagina: state.registrosPorPaginaEncomenda
    });


export default connect(mapStateToProps,
    {
        determinarPaginaAtual,
        limparFiltroEncomenda,
        buscarEncomendasEmpresa,
        determinarPaginaAtualEncomenda,
        buscarOpcoesFiltrosEmissaoesCte,
        buscarSeUsuarioVendeEncomendaComCte
    })(PainelGerenciarEncomendas)
